export default {
  init() {

    $('#slides-paginator').find('.item').each(function() {
      $(this).on('click', function() {
        var curr = $(this);
        var currLink = $(this).data("slide-for");
        var refElement = $('[data-place="' + currLink +'"]');
        $("html, body").animate({ scrollTop: refElement.offset().top }, {
          duration: 1000,
          complete: function() { 
            $('#slides-paginator .item').removeClass("act");
            curr.addClass('act');
          }
        });
      });
    });
  }
}
